const threeColumnBtn = document.querySelector(
  '.productsPage__header__layoutShift__btn__right__btn'
);
const twoColumnBtn = document.querySelector('.productsPage__header__layoutShift__btn__left__btn');
const productsCardList = document.querySelector('#productsCardLists');
let columnThreeFlag = false;

window.addEventListener('DOMContentLoaded', () => {
  let columnFlag = window.localStorage.getItem('columnThreeFlag');
  if (columnFlag === 'true') {
    productsCardList.classList.add('three');
    threeColumnBtn.classList.add('active__column');
    twoColumnBtn.classList.remove('active__column');
  } else {
    twoColumnBtn.classList.add('active__column');
    threeColumnBtn.classList.remove('active__column');
  }
});

threeColumnBtn.addEventListener('click', () => {
  twoColumnBtn.classList.add('active__column');
  threeColumnBtn.classList.remove('active__column');
  let columnThreeFlag = false;
  window.localStorage.setItem('columnThreeFlag', columnThreeFlag);
  productsCardList.classList.remove('three');
});

twoColumnBtn.addEventListener('click', () => {
  threeColumnBtn.classList.add('active__column');
  twoColumnBtn.classList.remove('active__column');
  let columnThreeFlag = true;
  window.localStorage.setItem('columnThreeFlag', columnThreeFlag);
  productsCardList.classList.add('three');
});
